import React from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import {
  IProps,
  IState,
  IDispatchProps,
} from './interfaces';
import {
  ISearchResultsLocaleLookupKeys,
  LocaleKeyTree,
} from '../../../../../localization';
import { UiSection } from '../../../../../enums';
import {
  VaultButton,
  PublishProfilesDialog,
} from '../../../../Shared';
import {
  enableClipperKeyboardControls,
  disableClipperKeyboardControls,
} from '../../../state/videoPlayer';

class VaultPublishOptions extends React.Component<IProps, IState> {
  private static readonly vaultButtonId = `${UiSection.SearchResults}.Vault`;
  private readonly localeLookupKeys: Readonly<ISearchResultsLocaleLookupKeys> = LocaleKeyTree.searchResults;

  state: Readonly<IState> = {
    isOpen: false,
  };

  toggleDialog = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen,
    });
  };

  render() {
    const {
      t,
      disabled,
      onPublish,
      selectedAssets,
      enableClipperKeyboardControlsConnect,
      disableClipperKeyboardControlsConnect,
    } = this.props;

    const {
      isOpen,
    } = this.state;

    return (
      <>
        <VaultButton
          variant="plainOnPaper"
          id={VaultPublishOptions.vaultButtonId}
          disabled={disabled}
          onClick={this.toggleDialog}
        >
          {t(this.localeLookupKeys.vaultButtonText)}
        </VaultButton>
        <PublishProfilesDialog
          isDialogOpen={isOpen}
          onPublish={onPublish}
          onClose={this.toggleDialog}
          selectedAssets={selectedAssets}
          onDialogEntered={disableClipperKeyboardControlsConnect}
          onDialogExited={enableClipperKeyboardControlsConnect}
        />
      </>
    );
  }
}

const mapDispatchToProps: IDispatchProps = {
  enableClipperKeyboardControlsConnect: enableClipperKeyboardControls,
  disableClipperKeyboardControlsConnect: disableClipperKeyboardControls,
};

export default connect(
  null,
  mapDispatchToProps,
)(withTranslation()(VaultPublishOptions));
